import { render } from "./QuizStart.vue?vue&type=template&id=34283bb6"
import script from "./QuizStart.vue?vue&type=script&lang=js"
export * from "./QuizStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__